import React from 'react';
import classNames from 'classnames';
import TabBar from './TabBar';
import ScrollablePanel from './ScrollablePanel';
import styles from './styles.module.scss';

const StatsSection = ({
  className,
  renderedPanel,
  tabs,
  onTabChanged
}) => {
  const [selectedTab, setSelectedTab] = React.useState(tabs[0]);
  React.useEffect(() => {
    onTabChanged && onTabChanged(selectedTab);
  }, [onTabChanged, selectedTab]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement(TabBar, {
    className: styles.tabs,
    tabs: tabs,
    selected: selectedTab,
    onSelected: setSelectedTab
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.panel
  }, /*#__PURE__*/React.createElement(ScrollablePanel, {
    className: styles.scrollable
  }, renderedPanel(selectedTab))));
};

export default StatsSection;